<template>
  <section   class="section section_bg main_page_content first_page">
    <loading-block v-if="is_load==false" :loading="!is_load"/>
    <div class="container-fluid   section_gray_bg">


      <div class="section_header mobile_div d-flex justify-content-center">
        <div class="col-12 mt-2" v-if="!(Object.keys(cart).length>0)">
          <h2>Корзина пуста!</h2>
          <p><router-link tag="a" :to="{name: 'shop_categorys'}">
            В каталог
          </router-link></p>
        </div>
        <div class="col-12 "  v-if="Object.keys(cart).length>0" >
          <h2 class="text-center"> Корзина  </h2>
          <p class="text-center"><router-link tag="a" :to="{name: 'user_page_items',params:{'user_id':cart[0].user_id}}">
            Продолжить покупки
          </router-link></p>
          <div class="col-12 mt-3 ml-0 pl-0">
            <UserCard v-if="cart.length>0 && cart[0].user"   :user="cart[0].user" route_name="user_page_items" />
          </div>
          <div v-if="cart.length>0 && Object.keys(cart).length>0" class="row cart_items mt-2 p-3 no-gutters  " v-for="(item,item_key) in cart" :key="item_key"
          >
            <div class="col-7 col-md-7 col-lg-7 text-break" v-if="item">
              <p>  <router-link    tag="a"
                  :to="{name: 'shop_item_id', params: { id: item.last_id }}" >{{ item.title}} </router-link></p>
              <p v-if="item.variant"><b>{{ item.variant.title }}</b></p>
              <p>{{ item.price}} {{ item.currency}}</p>
              <p    v-for="(option,option_key) in item.options" :key="option_key">
                <b v-if="  item.custom_options.length>0 && item.custom_options[option_key]!=null   && item.custom_options[option_key]==true   "> {{ option.title}} +{{ option.price}} {{item.currency}}</b>
              </p>
              <p>{{ item.custom_price }} * {{ item.count}}= {{ parseInt(item.custom_price) * parseInt(item.count)}} {{ item.currency}}</p>
            </div>

            <div class="col-5 col-md-5 col-lg-5" v-if="item">



              <p><button class="btn"><i class="fa fa-minus" @click="changeCountByType(item_key,'minus')"></i></button>&nbsp;<b>{{ cart[item_key]['count'] }}</b>&nbsp;<button class="btn"><i class="fa fa-plus" @click="changeCountByType(item_key,'plus')"></i></button></p>
              <p><button class="btn" type="submit" @click="deleteItem(item_key)"><i class="fa fa-remove"></i></button></p>
            </div>


          </div>

          <div  v-if="cart.length>0 && Object.keys(cart).length>0 "class=" col-12">

            <div class="alert alert-danger" v-if="is_error">
              <p>{{ error_message}}</p>
            </div>
            <div class="row mt-2">
              <div class="col-12 col-sm-12 col-md-6  col-lg-6"><p>Промокод</p></div>
              <div class="col-12  col-sm-12 col-md-6  col-lg-6" v-if="is_show_promocode">
                <input type="text" class="form-control" v-model="current_promocode"/>
                <br>
                <button class="btn" @click="acceptPromocode()">Применить</button>
              </div>
              <div class="col-12  col-sm-12 col-md-6  col-lg-6" v-if="is_show_promocode==false">
                {{ promocode.promocode}}
                <br>
                <p>{{ promocode.description }}</p>
                <br>
                скидка:
                <b v-if="promocode.type_discount=='percent'">-{{ promocode.discount }}%</b>
                <b v-if="promocode.type_discount=='sum'">-{{ promocode.discount }}</b>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-12 col-sm-12 col-md-6  col-lg-6"><p>Способ доставки</p></div>
              <div class="col-12  col-sm-12 col-md-6  col-lg-6">
                <select v-if="type_deliverys.length>0" class="form-control" @change="changeDeliveryType" v-model="current_delivery">
                  <option  v-for="(delivery,delivery_key) in type_deliverys" :value="delivery.id" :key="delivery_key"
                  >{{ delivery.title }}</option>
                </select>
              </div>
            </div>

            <div v-if="fields.length>0" class="row mt-2 " v-for="(field,field_key) in fields" :key="field_key"
            >
              <div class="col-12 col-sm-12 col-md-6  col-lg-6"><p>{{ field.title}}</p></div>
              <div class="col-12  col-sm-12 col-md-6  col-lg-6">
                <input v-if="field.type=='stroka'" type="text"  class="form-control" v-model="order_data[field.name]"/>
                <input v-if="field.type=='integer'|| field.type=='number'" type="number"  class="form-control" v-model="order_data[field.name]"/>
                <select v-if="field.type=='select'" class="form-control" v-model="order_data[field.name]">
                  <option v-if="field.options.length>0"   v-for="(option,option_key) in field.options" :value="option" :key="option_key"
                  >{{ option }}</option>
                </select>
              </div>
            </div>

            <p><button class="btn side2" v-if="islogin==false" @click="callModalLogin">
              Войдите чтобы создать заказ
            </button></p>
            <p v-if="current_delivery_obj" v-for="(one_delivery,total_key_delivery) in total_delivery" :key="total_key_delivery+'delivery_price'">
              <b >Стоимость доставки</b>:{{ one_delivery }} {{ total_key_delivery}}
            </p>
            <p v-if="current_delivery_obj">{{ current_delivery_obj.description }}</p>
            <p>Итого:</p>
            <p v-for="(one_total,total_key) in total" :key="total_key" v-if="one_total>0">{{ one_total }} {{ total_key}}</p>
            <p><button type="submit" v-if="islogin==true" class="btn" @click="createOrder()">Создать заказ</button></p>
          </div>
        </div>
      </div>










    </div>
  </section>
</template>

<script>

import Api from "@/models/Api";
import Vue from "vue";
import Editorjsrender from "@/models/Editorjsrender";
import {eventBus} from "@/main";
import LoadingBlock from "@/components/Custom/LoadingBlock";
import UserCard from "@/components/Custom/UserCard";



var Avatar = require('vue-avatar');


export default {
  name: 'Cart',

  components: {
    'editorjsrender': Editorjsrender,LoadingBlock,UserCard,
  },
  data() {
    return {
      "cart":null,
      "is_load":false,
      'user':null,

      "islogin":false,
      "total":null,
      "total_delivery":null,
      "is_error":false,
      "error_message":null,
      "fields":[],
      "order_data":{},
      'currencys':null,
      'type_deliverys':[],
      "current_delivery":0,
      "current_delivery_obj":null,
      "current_promocode":"",
      'is_show_promocode':true,
    }
  },
  mounted() {

    var app=this;
    if (app.$store.getters.ISAUTH) {
      var tmpUser = app.$store.getters.USER;

      app.user = tmpUser;
      app.islogin = true;


    }

    eventBus.$on('user_is_login', user => {
      this.islogin = false;
      if (typeof user === 'object') {
        if (user.api_token) {
          app.user = user;
          app.islogin = true;

        }
      }


    });

    Api.loadShopFields(function(data){
      app.cart=Api.getCart();
      app.type_deliverys=data.type_deliverys;
      app.current_delivery=app.type_deliverys[0].id;
      app.current_delivery_obj=app.type_deliverys[0];
      app.currencys=data.currencys;
      app.total=app.getTotalPrice();
      app.total_delivery=Api.getOnlyDeliveryPrice(app.currencys,app.current_delivery_obj)


      if(data.fields.length){
        var i=0;
        while(data.fields[i]){
          var current_field=data.fields[i];
          app.order_data[current_field.name]="";

          i++;
        }
        app.fields=data.fields;
      }



      app.is_load=true;
    })




  },
  methods: {
    getTotalPrice(){
     var app=this;
     var total=Api.getTotalPrice(app.currencys,app.current_delivery_obj);
     var total_delivery_price=Api.getOnlyDeliveryPrice(app.currencys,app.current_delivery_obj);


         for (const [key, value] of Object.entries(total)) {
           if(app.promocode) {
             if (value >= parseInt(app.promocode.order_from)) {
               if (app.promocode.type_discount == "sum") {
                 total[key] = value - parseInt(app.promocode.discount);
               } else {
                 var percent_sum = value / 100 * parseInt(app.promocode.discount);
                 total[key]      = value - percent_sum;
               }

               if (total[key] < 0) {
                 total[key] = 0;
               }
             }
           }
           total[key]=total[key]+total_delivery_price[key];
         }





     return total;
    },
    acceptPromocode(){
      var app=this;
      var json={};
      json["promocode"]=app.current_promocode;
      json["total"]=Api.getTotalPrice(app.currencys);
      app.is_error=false;
      Api.checkPromoCode(json,function(data){
        app.promocode=data.promocode;
        app.is_show_promocode=false;
        app.total=app.getTotalPrice();

          },function(err_message){

        app.is_error=true;
        app.error_message=err_message;
      }
      );
    },
    changeDeliveryType(){
     var app=this;
      app.type_deliverys.forEach(function(elem){
        if(elem.id==app.current_delivery){
          app.current_delivery_obj=elem;
          console.log('start each total price');
          app.total=app.getTotalPrice();
          app.total_delivery=Api.getOnlyDeliveryPrice(app.currencys,elem)
        }
      })

    },
    changeCountByType(item_key,type){
      var app=this;
      var cart=app.cart;
      if(cart[item_key]['count']==0){
        cart[item_key]['count']=1;
      }
      if(type=="plus" ){
        cart[item_key]['count']= cart[item_key]['count']+1;
      }
      if(type=='minus' && cart[item_key]['count']>1){
        cart[item_key]['count']= cart[item_key]['count']-1;
      }


      Api.setCart(cart);
      app.cart=cart;




      app.total={};
      app.total=app.getTotalPrice();
      Api.syncCart();
    },
    changeCount(item_key){

      var app=this;
      var cart=app.cart;
      if(cart[item_key]['count']==0){
        cart[item_key]['count']=1;
      }


      Api.setCart(cart);
      app.cart=cart;




      app.total={};
      app.total=app.getTotalPrice();
      Api.syncCart();
    },
    changeOptions(key){
      var app=this;
      var custom_price=parseInt(app.item.price);
      if(app.item.options.length>0){
        app.item.options.forEach(function(item, i, arr) {

          if(app.custom_options[i]){
            custom_price+=parseInt(item.price);
            app.custom_price=custom_price;
          }
        });

      }
    },
    deleteItem(item_key){

      var app=this;

      Vue.delete(this.cart, item_key);
       Api.setCart(app.cart);
      app.total={};
      app.total=app.getTotalPrice();
      Api.syncCart();
    },
    callModalLogin() {
      eventBus.$emit("call_modal_add_project", {type: "login",})
      {

      }
    },
    createOrder(){
      var app=this;
      var cart=app.cart;
      var params={};
      params.cart=cart;
      params.client_data=app.order_data;
      params.delivery_id=app.current_delivery;
      if(app.promocode && app.promocode.promocode){
      params.promocode=app.promocode.promocode;
      }
      try{
        if(localStorage.getItem('partner_id')!=null){
          params.partner_id=localStorage.getItem('partner_id');
        }
      }catch(err){

      }

      Api.createShopOrder(params,function(){
        Api.setCart([]);
        Api.syncCart();
        app.$router.push({path: "/invoices"});

        app.is_error=false;
      },function(message){
      app.is_error=true;
      app.error_message=message;
      })
    }




  }
};
</script>
